import { gql } from '@apollo/client';
import useMutation from 'api/hooks/useMutation';

const LOG_DEPLOYMENT = gql`
  mutation LogDeployment($analyticsFileId: uuid!) {
    insert_analytics_file_deployments_one(object: { analyticsFileId: $analyticsFileId }) {
      id
    }
  }
`;

export default function useLogDeployment(apolloOptions = {}) {
  const [executeMutation, response] = useMutation(LOG_DEPLOYMENT, {
    ...apolloOptions,
  });

  const logDeployment = ({ analyticsFileId }) => {
    return executeMutation({
      variables: {
        analyticsFileId,
      },
    });
  };

  return [logDeployment, response];
}
